import { GlobalEnv } from '../../../lib/webx'
// import { isSoldOut } from '../../../lib/webx/mpx/mixins/page_detail/judge'
// import { EnumGoodsDetailIsSpike } from '../../../lib/webx/defines'
import { is } from '@didi/webx-js'

const addHook = (hooks, key, fn) => {
  if (!hooks[key]) {
    hooks[key] = fn
  } else if (Array.isArray(hooks[key])) {
    hooks[key].unshift(fn)
  } else {
    hooks[key] = [fn, hooks[key]]
  }
}
const getPubType = () => {
  switch (true) {
    case !!is('passenger'):
      return 'na'
    case !!is('weixin'):
      return 'weixin'
    case !!is('alipay'):
      return 'alipay'
    default:
      return 'others'
  }
}
const isSoldOut = goods => {
  switch (goods.rights.theme) {
    case 'spike_time_limit':
      return goods.endTime - goods.currentTime < 0 || goods.balanceLeft === 0
    case 'spike_amount_limit':
      return goods.balanceLeft === 0
    default:
      return goods.balanceLeft === 0
  }
}
const PubType = getPubType()
export const RightMixin = PageConfig => {
  addHook(PageConfig.hooks, 'beforeRender', function (MallRenderData) {
    const goods = this.$data.$_.goods
    const { product_id } = goods.package[0] || {}
    // 判断不是专车类型的直接return
    if (product_id !== 115) {
      return MallRenderData
    }
    MallRenderData.template = 'right'
    MallRenderData.components = [
      {
        name: 'right-main',
        data: {
          ...goods,
          isSoldOut: isSoldOut(goods),
          showText: goods.showText,
          PubType,
        },
      },
      ...(goods.is_sale === 0
        ? []
        : [
            {
              name: 'right-operations',
              data: {
                isLogin: GlobalEnv.isLogin,
                uid: GlobalEnv.loginInfo.uid,
                isSoldOut: isSoldOut(goods),
                price: goods.showCash,
                currency: goods.currency,
                showText: goods.showText,
                isTimeLimit: goods.rights.theme === 'spike_time_limit',
                PubType,
              },
            },
          ]),
    ]
    return MallRenderData
  })
  addHook(PageConfig.hooks, 'afterOrder', function ({ errno, orderId }) {
    const goods = this.$data.$_.goods
    const { productId } = goods.package[0] || {}
    // 判断不是专车类型的直接return
    if (productId !== 115) {
      return false
    }
    const component = this.MallRenderData.components.find(
      component => component.name === 'pay-result'
    )
    if (component) {
      component.data.isRight = productId === 115
    }
  })
  return {}
}
